var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileNativeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0_332_2503)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_332_2503",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_332_2503",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_332_2503",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD8ElEQVR4nO2dvU5UQRiGRxMbg1hYil6BP4VGbOw0WfhmwYKNMrNoogkXYGtBY5bKRLgBE7WwsjLQaYvJ7swSiZCtFOMFAEaxATO7JC7DHthFYM/7ct5kms1kz/Oc78yZ2W0+pbJkyZIlS5YUpzx+7ZSzMuKsfuOtLDqjf3qrN9M8nJW1OqvVbwJ7cFAMcSY/7K2udfsG+/8fteCiULM5MXHSG5lMwY3cPLhVoze81aXgptDCVgy/fZQUUsLS3nqa/kkY/dsbPe2K+Tveyqt0rwT544yemLdyy1uZqrNHK6ViZUghJGx+8Z7hrCzPm4HLzfOckWfpLIbecKMy2Mwa2J3R36O5NYiNPpxI4pVRLcql1oWTH23fKKPf+wdyPum68zbX563MxPPjz9u4zruW398oynr0oI2otKdxtG0WlOfJc+Vluzdq3ub69rr253vDF1rNb/5874LkHyd9vzf6RVS81yrtcUaWmqErYwPXk+ZWrX6StoJUi4P9ibzFwf7oYVtSaY8zstoMXR7Xp5PmVoqDufbf7zKzW1HqN93o2Xj+zs933z8WHw2dSbrGQqHQExVkVaU9seRuc8tj+mL7BdFHMb4epF8q0ilwJxu7P+ThrLw9aL+up1PgsOl3uxB+a7Tz24K+IJ/G7p5LxSoxenZTqRMH7df17Ac4/E4J72/ftVeV/jBnc72H5dfV7Be4XLh91lv91Btd9VZ+HcGKWHFGf3RWHnbyZ+GxKQhKPJofHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwux8cMLsfHDC7Hxwwu1/cWDI0Y1QkmbO53m0FMXpFobVe9aNyQ5GkbPM38VqvRs2JQ0NfRRJv9DRec+IW7bvjXuqIcUW5Ctm+u1WDe2/kG3JRKvfzV5yVZcgG9yHO5IdD5+Voea97K1PhPYyw0S8UCj31PcPo6Z0rQ2+006Y1VfFGJuMjItEoKbSE7pkBPF4pyMM1XEqddAZNXcLS3rGnYI4a3GsqKWHzCyeSxpFYFp2VtfSvBlnzRn8JR9vADrOBZ8mSJUsWdVzzF1HUq2Kzi919AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNativeIcon);
export default __webpack_public_path__ + "static/media/mobileNativeIcon.bf21f507a0eba6e5fe8a906f57a34c51.svg";
export { ForwardRef as ReactComponent };